export default __webpack_public_path__ + "static/media/pn.a59daf46.svg";